import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-did-doc',
  templateUrl: './did-doc.component.html',
})
export class DidDocComponent implements OnInit {
  did: any;
  document: any;

  constructor(private route: ActivatedRoute, private service: SharedService) {
    this.did = this.route.snapshot.queryParamMap.get('did');
    this.service.getDidDocument(this.did).subscribe( data => {
      this.document = data.didDocument;
    })
  }

  ngOnInit(): void {
  }

}
